'use client'
import {
  __spreadProps,
  __spreadValues
} from "./chunk-E5AFJQUS.mjs";

// src/warning/WarningIcon.tsx
import { jsx } from "react/jsx-runtime";
var WarningIcon = (props) => /* @__PURE__ */ jsx(
  "svg",
  __spreadProps(__spreadValues({
    width: "12",
    height: "13",
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {
    children: /* @__PURE__ */ jsx(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M5.99946 0.742798L11.6278 10.2222H0.371094L5.99946 0.742798ZM2.12783 9.22216H9.87109L5.99946 2.70151L2.12783 9.22216ZM6.49946 4.72216V7.22216H5.49946V4.72216H6.49946ZM6.49946 7.71716V8.72216H5.49946V7.71716H6.49946Z",
        fill: "currentColor"
      }
    )
  })
);

export {
  WarningIcon
};
//# sourceMappingURL=chunk-P77G47NU.mjs.map